import React, { useCallback, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FiArrowRight, FiMessageSquare } from "react-icons/fi";
import { CENTERS, getCenter, isWorkspaceEnabled, centerPath } from "../../constants/centers";
import { ROUTES } from "../../app/routes";
import "../../styles/CenterHome.css";
const CenterHomePage: React.FC = () => {
    const { centerId } = useParams<{
        centerId: string;
    }>();
    const navigate = useNavigate();
    const center = getCenter(centerId);
    const workspaces = useMemo(() => (center ? center.workspaces.filter(isWorkspaceEnabled) : []), [center]);
    const openWorkspace = useCallback((path: string) => navigate(path), [navigate]);
    if (!center) {
        return (<div className="center-home center-home--missing">
        <h1 className="center-home__title">Center not found</h1>
        <p className="center-home__blurb">
          Pick one of the five Centers to get going.
        </p>
        <div className="center-home__missing-links">
          {CENTERS.map(c => (<button key={c.id} type="button" className="center-home__missing-link" onClick={() => navigate(centerPath(c.id))}>
              <span className="center-home__missing-link-icon">{c.icon}</span>
              {c.name}
            </button>))}
        </div>
      </div>);
    }
    return (<div className="center-home" style={{ ["--center-accent" as string]: `var(${center.accentVar})` }}>
      <header className="center-home__header">
        <div className="center-home__eyebrow">
          <span className="center-home__eyebrow-icon">{center.icon}</span>
          <span>Center</span>
        </div>
        <h1 className="center-home__title">{center.name}</h1>
        <p className="center-home__blurb">{center.blurb}</p>
      </header>

      <section className="center-home__section" aria-labelledby="center-attention">
        <div className="center-home__section-head">
          <h2 className="center-home__section-title" id="center-attention">
            Needs you
          </h2>
        </div>
        <div className="center-home__empty">
          <p className="center-home__empty-title">Nothing waiting on you here.</p>
          <p className="center-home__empty-note">
            Live counts from each workspace land here — see the note below.
          </p>
        </div>
      </section>

      <section className="center-home__section" aria-labelledby="center-workspaces">
        <div className="center-home__section-head">
          <h2 className="center-home__section-title" id="center-workspaces">
            Workspaces
          </h2>
          <span className="center-home__section-count">{workspaces.length}</span>
        </div>

        <div className="center-home__grid">
          {workspaces.map(w => (<button key={w.path} type="button" className="center-home__card" onClick={() => openWorkspace(w.path)}>
              <span className="center-home__card-top">
                <span className="center-home__card-icon">{w.icon}</span>
                <FiArrowRight className="center-home__card-arrow" size={14} aria-hidden="true"/>
              </span>
              <span className="center-home__card-name">{w.name}</span>
              <span className="center-home__card-blurb">{w.blurb}</span>
              {w.assist && (<span className="center-home__card-assist">
                  <span className="center-home__card-assist-dot" aria-hidden="true"/>
                  {w.assist}
                </span>)}
            </button>))}
        </div>
      </section>

      <section className="center-home__assist" aria-label="Ask AI">
        <div className="center-home__assist-copy">
          <p className="center-home__assist-title">Want a hand?</p>
          <p className="center-home__assist-note">
            Ask about anything in {center.shortName} — AI works from the same book you do.
          </p>
        </div>
        <button type="button" className="center-home__assist-btn" onClick={() => navigate(ROUTES.CHAT)}>
          <FiMessageSquare size={13} aria-hidden="true"/>
          Open chat
        </button>
      </section>
    </div>);
};
export default CenterHomePage;
